<template>
  <ux-modal
    class="bind-email"
    width="368px"
    v-model="showModal"
    :title="$t('HT.bindEmail')"
    :close="close"
  >
    <div class="bindemail-cont">
      <!-- 内容 -->
      <div class="bindemail-verify">
        <ux-form
          class="my-vertical-form"
          ref="form"
          :rules="rules"
          :data="formData"
          hide-btn
          width="232px"
          hideRequired
        >
          <!-- 绑定邮箱 -->
          <ux-form-item
            :label="$t('HT.bindEmail')"
            prop="email"
            key="email"
            :error="errorList.email"
          >
            <ux-input
              noSpace
              v-model="formData.email"
              :placeholder="$t('HT.rules.changeEmail.oldEmail')"
            ></ux-input>
          </ux-form-item>

          <!-- 图形验证码 -->
          <ux-form-item
            :label="$t('HT.imgcode')"
            prop="imgCode"
            key="imgCode"
            :error="errorList.imgCode"
          >
            <ux-input
              noSpace
              v-model="formData.imgCode"
              :placeholder="$t('HT.imgcode')"
              class="min-input"
            ></ux-input>
            <img-verify ref="refImgVerify" v-model="prefix" />
          </ux-form-item>

          <!-- 验证码 -->
          <ux-form-item :label="$t('HT.code')" prop="code" key="code" :error="errorList.code">
            <ux-input
              class="min-input"
              noSpace
              v-model="formData.code"
              :placeholder="$t('HT.code')"
              :regular="regPositiveInteger"
            ></ux-input>
            <time-button
              class="time-button"
              ref="time"
              text
              :time="120"
              @click="getCode"
            ></time-button>
          </ux-form-item>
        </ux-form>
      </div>
    </div>
    <template slot="footer">
      <div class="bindemail-footer">
        <ux-button plain @click="close">{{ $t('HT.cancel') }}</ux-button>
        <ux-button type="primary" @click="confirm">{{ $t('HT.bind') }}</ux-button>
      </div>
    </template>
  </ux-modal>
</template>

<script>
import { rules } from '@l/rules.js';
import timeButton from '@/views/template/timeButton';
import imgVerify from '@c/imgVerify/imgVerify';

export default {
  name: 'BindEmail',
  components: {
    timeButton,
    imgVerify
  },
  data() {
    return {
      showModal: false,
      regPositiveInteger: rules.positiveInteger().pattern, // 包括0正整数
      rules: this.$rul.changeEmail(),
      formData: {
        email: '',
        code: '',
        imgCode: ''
      },
      // 错误信息
      errorList: {
        email: '',
        code: '',
        imgCode: ''
      },
      prefix: '' // 图形验证码前缀
    };
  },
  created() {
    this.$nextTick(() => {
      this.showModal = true;
    });
  },

  methods: {
    /**
     * 获取验证码
     */
    getCode() {
      const errList = [];
      this.$refs['form'].validateField(['email'], (res) => {
        if (res) {
          errList.push(res);
        }
      });
      const { imgCode, email } = this.formData;

      if (!imgCode) {
        this.errorList.imgCode = this.$t('HT.login.imgCode.placeholder');
        return;
      }

      if (errList.length === 0) {
        this.$uxLoading.show();
        this.clearErrorMsg();

        const params = {
          email,
          code: imgCode,
          prefix: this.prefix
        };

        this.$api.user
          .getChangeEmailCode(params, { hideMsg: true })
          .then((res) => {
            if (res.code == 10000) {
              this.$refs.time.start();
            }
          })
          .catch((err) => {
            const { sub_msg } = err.response.data;
            this.errorList.code = sub_msg;
            this.$refs.refImgVerify.getKaptcha();
            this.formData.imgCode = '';
          });
      }
    },

    /**
     * 关闭弹窗
     */
    close() {
      this.showModal = false;
      let timer = setTimeout(() => {
        clearTimeout(timer);
        timer = null;
        this.$emit('close');
      }, 500);
    },

    /**
     * 确认回调
     */
    confirm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$uxLoading.show();
          this.clearErrorMsg();
          this.$api.user
            .changeEmail(this.formData, { hideMsg: true })
            .then((res) => {
              if (res.code == 10000) {
                this.$uxMessage.success(this.$t('HT.addApi.bindSuccess'));
                this.$emit('update-info');
                this.close();
              }
            })
            .catch((err) => {
              const { sub_msg, sub_code } = err.response.data;
              const emailCode = ['error.email', 'existing.email'];
              if (emailCode.includes(sub_code)) {
                // 邮箱错误
                this.errorList.email = sub_msg;
              } else {
                // 验证码错误
                this.formData.code = '';
                this.$nextTick(() => {
                  this.errorList.code = this.$t('HT.login.text2');
                });
              }
            });
        }
      });
    },
    /**
     * 清空错误信息
     */
    clearErrorMsg() {
      for (const key in this.errorList) {
        if (Object.hasOwnProperty.call(this.errorList, key)) {
          this.errorList[key] = '';
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.bindemail-cont {
  position: relative;
  display: flex;
  justify-content: space-between;
  padding-top: 40px;

  .bindemail-verify {
    position: relative;
    flex: 1;
    padding: 0 40px;

    .bindemail-errorbox {
      color: $color-error;
    }

    .bindemail-verify-item {
      width: 240px;
      margin-bottom: 24px;
      color: $color-text-secondary;

      &:last-of-type {
        margin-bottom: 0;
      }

      .verify-label {
        display: flex;
        align-items: center;
        margin-bottom: 8px;
        font-size: 12px;
        height: 16px;
        color: $color-text-secondary;
      }

      .verify-control {
        display: flex;
        align-items: center;
        color: $color-title;
        height: 32px;

        &.verify-code {
          justify-content: flex-start;

          .ux-input {
            width: 96px;
          }
        }
      }
    }

    .time-button {
      margin-left: 24px;
    }

    .min-input {
      width: 110px;
      margin-right: 20px;
    }
  }
}

.bindemail-footer {
  text-align: right;
  padding-top: 32px;

  .ux-button {
    margin-left: 8px;
  }
}
</style>
